/* import Vue from 'vue'

var numeral = require('numeral')

Vue.filter('formatNumberCurrency', (value) => {
  let formatted = ''
  if (value <= 0.01) {
    formatted = '0.00'
  } else {
    formatted = numeral(value).format('0,0.00')
  }
  return formatted === 'NaN' ? value : formatted
})
*/

import Vue from 'vue'
import numeral from 'numeral'

// Opcional: configurar idioma local si lo necesitas (ej. español)
// numeral.locale('es')

Vue.filter('formatNumberCurrency', (value) => {
  // Manejar valores nulos, indefinidos o strings vacíos
  if (value === null || value === undefined || value === '') {
    return '0.00' // O retorna value según prefieras
  }

  const number = Number(value)

  // Validar si realmente es un número válido
  if (isNaN(number)) {
    return value
  }

  return `${numeral(number).format('0,0.00')}`
})
